import styled from 'styled-components';
import { Flex } from '../../../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionGoalsDialogContent' })
    .attrs({
        width: '100%',
        pt: 1,
    })``;
